import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { Page403 } from "../../../../components/templates/Page403";

const Forbidden: FC = () => {
  return <Page403 />;
};

export const Route = createFileRoute("/_private/_errors/forbidden/")({
  component: Forbidden,
});
